// Asset QR label printing — sized for a 50 × 30 mm label-printer sticker,
// ONE label per page (page-break-after each). Shared by the detail page
// (single label) and the list (batch print). Layout: QR on the left (~26mm),
// name / serial / asset-id stacked on the right.

function escapeHtml(s) {
  return String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]))
}

/**
 * @param {Array<{url:string, line:string, serial?:string, id:(number|string)}>} labels
 *   url = QR code data-URL, line = human label text, serial = S/N, id = asset id.
 */
export function openLabelPrint(labels) {
  const list = (Array.isArray(labels) ? labels : []).filter(Boolean)
  if (!list.length) return
  const w = window.open('', '_blank', 'width=420,height=320')
  if (!w) return

  const cells = list.map(({ url, line, serial, id }) => `
    <div class="label">
      ${url ? `<img src="${url}" alt="QR"/>` : '<div class="qr-missing"></div>'}
      <div class="info">
        <div class="name">${escapeHtml(line)}</div>
        ${serial ? `<div class="meta">S/N: ${escapeHtml(serial)}</div>` : ''}
        <div class="id">ASSET #${escapeHtml(id)}</div>
      </div>
    </div>`).join('')

  w.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>ป้ายสินทรัพย์</title>
  <style>
    @page { size: 50mm 30mm; margin: 0; }
    * { margin: 0; padding: 0; box-sizing: border-box; font-family: 'Noto Sans Thai', Arial, sans-serif; }
    html, body { width: 50mm; }
    .label {
      width: 50mm; height: 30mm;
      display: flex; align-items: center; gap: 1.2mm;
      padding: 1.5mm; overflow: hidden;
      page-break-after: always; break-after: page;
    }
    .label:last-child { page-break-after: auto; break-after: auto; }
    .label img, .qr-missing { width: 26mm; height: 26mm; flex: none; }
    .qr-missing { border: 0.2mm dashed #cbd5e1; }
    .info { flex: 1; min-width: 0; overflow: hidden; }
    .name {
      font-size: 6.5pt; font-weight: 700; line-height: 1.15; color: #0f172a;
      display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;
    }
    .meta { font-size: 6pt; color: #334155; margin-top: 0.6mm; word-break: break-all; }
    .id { font-size: 6pt; color: #64748b; margin-top: 0.6mm; letter-spacing: 0.03em; }
    @media screen { body { background: #f1f5f9; padding: 6mm; }
      .label { background: #fff; box-shadow: 0 1px 4px rgba(0,0,0,.15); margin-bottom: 3mm; } }
  </style></head>
  <body onload="setTimeout(function(){window.print()}, 300)">${cells}</body></html>`)
  w.document.close()
}
